'use client';

import { useRouter } from 'next/navigation';
import { usePreloader } from '@/components/PagePreloader';
import { scrollToWithLenis } from '@/components/LenisProvider';

export const usePageNavigation = () => {
  const router = useRouter();
  const { triggerTransition } = usePreloader();

  const navigateToPage = async (url: string, currentPath?: string) => {
    // Don't navigate if we're already on the target page
    if (currentPath && url === currentPath) {
      return;
    }

    try {
      // Start preloader and preloading process (this now handles navigation internally)
      await triggerTransition(url, router);
      
    } catch {

      // Fallback: navigate normally without preloader, disable Next.js auto-scroll
      router.push(url, { scroll: false });
      
      // Scroll to top since preloader won't handle it in this fallback case
      // Add a small delay to ensure navigation has started
      setTimeout(() => {
        // Try to use Lenis for smooth scroll to top
        const lenisSuccess = scrollToWithLenis(0, { duration: 0.8 });
        
        // Fallback to native scroll if Lenis is not available
        if (!lenisSuccess) {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
          });
        }
      }, 100);
    }
  };

  return {
    navigateToPage,
  };
};
